import * as VueToastification from "vue-toastification";
import type { PluginOptions as ToastPluginOptions } from "vue-toastification";
import type { Plugin } from "vue";
import get from "lodash-es/get";

import "vue-toastification/dist/index.css";

const options: ToastPluginOptions = {
  shareAppContext: true,
  position: get(
    VueToastification,
    "default.POSITION.TOP_CENTER",
    "top-center",
  ) as VueToastification.POSITION,
  toastDefaults: {
    [get(VueToastification, "default.TYPE.ERROR", "error")]: {
      timeout: 5000,
    },
    [get(VueToastification, "default.TYPE.SUCCESS", "success")]: {
      timeout: 3000,
      hideProgressBar: false,
    },
  },
};

const plugin: Plugin = {
  install(app, options) {
    const installPluginMethod = get(
      VueToastification,
      "default",
    ) as Plugin["install"];

    if (installPluginMethod) {
      installPluginMethod(app, options);
    }
  },
};

export default defineNuxtPlugin((nuxtApp) => {
  if (import.meta.client) {
    nuxtApp.vueApp.use(plugin, options);
  }
});
